export default (inputValue: unknown): inputValue is string =>
  typeof inputValue === 'string' || inputValue instanceof String;
